import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import { routes } from '$src/routes';
import PrivateRoute from '$src/components/PrivateRoute';
import Introduction from '$src/pages/Onboarding/Introduction';
import AlertPreferences from '$src/pages/Onboarding/AlertPreferences';
import EmergencyContacts from '$src/pages/Onboarding/EmergencyContacts';
import DeviceAuthorization from '$src/pages/Onboarding/DeviceAuthorization';
import Location from './Location';
import ProfessionalMonitoring from './ProfessionalMonitoring/ProfessionalMonitoring';
import SOSTurnOn from './SOSTurnOn';
import SOSSetUp from './SOSSetUp';
import SetupComplete from './SetupComplete/SetupComplete';
import HowVSGWorks from './SetupComplete/HowVSGWorks';
import OnboardingError from './OnboardingError';
import EventsAndPrivacy from './SetupComplete/EventsAndPrivacy';
import PracticeMode from './PracticeMode';
import {withOnboarding30Redirect} from './withOnboarding30Redirect'

function OnboardingRouter(props) {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute path={`${path}${routes.onboardingLocation}`}>
          <Location {...props} />
      </PrivateRoute>
      <PrivateRoute exact path={routes.onboardingDevices} component={DeviceAuthorization} />
      <PrivateRoute exact path={routes.onboardingIntroduction} component={Introduction} />
      <PrivateRoute exact path={routes.onboardingAlertPreferences} component={AlertPreferences} />
      <PrivateRoute exact path={routes.onboardingEmergencyContacts} component={EmergencyContacts} />
      <PrivateRoute exact path={routes.onboardingProfessionalMonitoring} component={ProfessionalMonitoring} />
      <PrivateRoute exact path={routes.onboardingSOSTurnOn} component={SOSTurnOn} featureFlag="stark-feature-allow-sos-support" />
      <PrivateRoute exact path={routes.onboardingSOSSetUp} component={SOSSetUp} featureFlag="stark-feature-allow-sos-support" />
      <PrivateRoute exact path={routes.onboardingSetupComplete} component={SetupComplete} />
      <PrivateRoute exact path={routes.onboardingHowVSGWorks} component={HowVSGWorks} />
      <PrivateRoute exact path={routes.onboardingError} component={OnboardingError} />
      <PrivateRoute exact path={routes.onboardingEventsAndPrivacy} component={EventsAndPrivacy} />
      <PrivateRoute exact path={routes.onboardingPracticeMode} component={PracticeMode} />
      <Redirect from={path} to={`${path}${routes.onboardingLocation}`} />
    </Switch>
  );
}

export default withOnboarding30Redirect(OnboardingRouter);